const reasons = [
    {
        id: 1,
        title: 'الجودة والابداع',
        describtion: 'الابتكار والابداع في عملنا هو اساس الجودة العالية المقدمة في برنامجنا'
    },
    {
        id: 2,
        title: 'السهولة والسرعة في انجاز المعاملات',
        describtion: 'نقدم لزوارنا أسهل الانظمةالمحاسبية في التعامل ليحصل على عمل سلس ومرن لتحقيق النتائج المرضية'
    },
    {
        id:3 ,
        title: 'دعم فني على مدار الساعة',
        describtion: 'نسعى ان نكون بالقرب في جميع الاوقات بجوار عملائنا لكي تبقى خدماتنا وأعمالهم متواصلة على مدار اليوم'
    },
    {
        id:4 ,
        title: 'دعم فني على مدار الساعة',
        describtion: 'نسعى ان نكون بالقرب في جميع الاوقات بجوار عملائنا لكي تبقى خدماتنا وأعمالهم متواصلة على مدار اليوم'
    }
]


export default reasons